import { RecordingPreference } from '@api/generated/graphql';
import { getQueue, logWorkspace, serviceState } from '../..';
import getQueues from '../../getQueues';
import ServiceQueue from '../../types/ServiceQueue';
import * as Telecom from '@servicetitan/telecom-rtcs-client';

async function handleQueueCreated(event: Telecom.QueueCreatedEvent) {
  const queue = getQueue(event.queueId);

  logWorkspace('service:queue:created:' + queue?.name, event);

  if (queue) {
    serviceState.queues = await getQueues();
    return;
  }

  const newQueue: ServiceQueue = {
    id: event.queueId,
    name: event.queueName,
    status: {
      abandonedSessions: 0,
      activeSessionCount: 0,
      averageWait: 0,
      estimatedWait: 0,
      longestWait: 0,
      missedSessions: 0,
      recipientCount: 0,
      totalSessions: 0,
      activeRecipientCount: 0,
      availableRecipientCount: 0,
    },
    memberIds: event.agentIds,
    sessions: [],
    inboundRecording: RecordingPreference.Automatic,
    outboundRecording: RecordingPreference.Automatic,
  };

  serviceState.queues = [...serviceState.queues, newQueue];
}

export default handleQueueCreated;
